import React, { useState } from "react";
import Login from "./login";
import Register from "./register";
import styles from "./auth.module.css";
import Loader from "../../components/loader/loader";

const UserAuth = () => {
  const [autoEmailorPhone, setAutoEmailorPhone] = useState<string>("");
  const [autoPassword, setAutoPassword] = useState<string>("");

  return (
    <>
      <div className={`MainContainer ${styles.authWrapper}`}>
        <Login
          autoPassword={autoPassword}
          autoEmailorPhone={autoEmailorPhone}
        />
        <div className={styles.loginDivider}></div>
        <Register
          setAutoEmailorPhone={setAutoEmailorPhone}
          setAutoPassword={setAutoPassword}
        />
      </div>
    </>
  );
};

export default UserAuth;
